/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Modal } from '@madeeasy/universal-login';
// import '@madeeasy/universal-login/dist/main.css'; // needed for the production
import HamburgerMenu from '../sidebar/HamburgerMenu';
import TopRightUserInfo from '../topright/TopRightUserInfo';
import { HeaderContext } from '../../../contexts/headerContext';
import BreadCrumb from './BreadCrumb';
import {
  getOrganizationPropertiesByHost,
} from '../../../utils/helpers';
import { nextiasLogo } from '../../../utils/constants';
import { useMiscellaneousData } from '../../../contexts/ssr-miscellaneous-context';

const Header = ({
  logoShow, userInfo, title, mobileShow, isUserInfo,
}) => {
  // console.log('Header userInfo', userInfo);
  const { miscellaneousData } = useMiscellaneousData();
  const currentOrg = getOrganizationPropertiesByHost(miscellaneousData?.hostname);
  const { headerData } = useContext(HeaderContext);
  const [showLogin, setShowLogin] = useState(false);

  function toggleModal() {
    console.log('toggleModal');
    setShowLogin(false);
  }

  // <div className="mb-3 font-medium sm:mb-0 md:mb-0 lg:mb-0">
  //         <h1 className="text-2xl">{capitalizeWords(removeDashFromString(slug))}</h1>
  //         <small className="text-sky-800 underline decoration-1 pb-2">
  //           <Link to="/home">Home </Link>
  //           /
  //           {' '}
  //           {capitalizeWords(removeDashFromString(slug))}
  //         </small>
  //       </div>

  return (
    <div className="w-full flex justify-center">
      {/* eslint-disable-next-line react/jsx-no-bind */}
      {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}

      <div className="flex container items-center justify-between px-2 lg:px-[18px] py-2">
        {/* Left Section: Burger Menu and Logo */}
        <div className="flex items-center">
          {/* Hamburger Icon */}
          {
            !isUserInfo && (
            <div className="space-y-1 space-x-1">
              <HamburgerMenu />
            </div>
            )
          }

          {/* Logo */}
          { logoShow === '1' ? (
            <div>
              <div className={`${logoShow === '1' ? '' : 'lg:hidden'} w-full text-center font-bold text-lg text-white`}>
                <Link href={`${getOrganizationPropertiesByHost(miscellaneousData?.hostname)?.organizationName === 'nextias' ? `https://${miscellaneousData?.hostname}` : `https://${miscellaneousData?.hostname}`}`}>
                  <Image width={500} height={500} src={getOrganizationPropertiesByHost(miscellaneousData?.hostname)?.logo || nextiasLogo} alt="logo" className="w-[144px] h-6 lg:w-[175px] lg:h-10" />
                </Link>
              </div>
            </div>
          ) : (
          // <div className="text-defaultFont font-semibold hidden lg:block">{headerData.headerTitle || title}</div>
          // <div className="mb-3 font-medium sm:mb-0 md:mb-0 lg:mb-0 hidden lg:block">
          //   <h1 className="text-2xl">{headerData.headerTitle || title}</h1>
          //   {headerData.headerTitle !== 'Home'
          //   && (
          //   <small className="text-sky-800 underline decoration-1 pb-2">
          //     <Link to="/home">Home </Link>
          //     /
          //     {' '}
          //     {headerData.headerBreadCrumb || title}
          //   </small>
          //   )}
          // </div>
            <BreadCrumb type={1} />
          ) }

          { mobileShow === '1' ? (
            <div>
              <div className={`${logoShow === '1' ? '' : 'lg:hidden'} w-full text-center font-bold text-lg text-white`}>
                <Link href={`${currentOrg?.organizationName === 'nextias' ? `https://${miscellaneousData?.hostname}` : `https://${miscellaneousData?.hostname}`}`}>
                  <Image width={500} height={500} src={currentOrg?.logo || nextiasLogo} alt="logo" className="w-[128px] h-6 lg:w-[175px] lg:h-8" />
                </Link>
              </div>
            </div>
          ) : ''}

        </div>

        {/* Right Section: Notification Icon */}
        {!isUserInfo && (
          userInfo?.name ? (
            <div className="flex justify-start items-center gap-4">
              {/* <Notification /> */}
              <div className="hidden lg:flex cursor-pointer">
                <TopRightUserInfo userInfo={userInfo} />
              </div>
            </div>
          ) : (
            <button
              onClick={() => { setShowLogin(!showLogin); }}
              type="button"
              className="px-4 py-1 rounded-md bg-[#045692] text-white"
            >
              Login
            </button>
          )
        )}

      </div>
    </div>
  );
};

Header.propTypes = {
  isUserInfo: PropTypes.any,
};

export default Header;
